import React, { useContext } from 'react'
import SignupContext from 'modules/react/signup/SignupContext'

export default function Step1RightContent () {

  const { course } = useContext(SignupContext)

  return (
    <>
      <div className="title title--h4">Gymnasial supplering</div>
      <div className="wysiwyg">Tilmelding til <b>{course.post_title}</b>.</div>
    </>
  )
}